<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import ShopifyAppsComponent from './component.shopifys.svelte'
    import ShopifyAppsUpdateComponent from './component.update.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Aplicaciones de Shopify" subtitle="Consulta y gestión de aplicaciones de Shopify" />
        <ShopifyAppsComponent />
    </div>
</View>

<ModalContainer id="shopify_update_modal" title="Actualizar aplicacion de shopify" >
    <ShopifyAppsUpdateComponent />
</ModalContainer>
